// Componente para a aba 6 - Gerenciamento dos Pagamentos.

import React from "react";
import axios from "axios";

const PagamentosTabAners = ({
    id,
    token,
    responsePagamento,
    dataFormato,
    money,
    selectedPayment,
    setSelectedPayment,
    responseParam
}) => {
    function deletePagamento(n) {
        axios
            .post(
                `/api/remove/payment/${n}`,
                { token, responseParam },
                {
                    withCredentials: true,
                }
            )
            .then((response) => {
                window.location = response.data;
            });
    }

    function modalNovoProcesso() {
        return (
            <div className="row">
                <div
                    className="col-xl-3 col-lg-4 col-md-4 div-button-success text-white"
                    title="Gerar Novo Processo"
                    data-toggle="modal"
                    data-target="#exampleModal"
                >
                    <i className="fas fa-plus"></i>Gerar Novo Pagamento
                </div>
            </div>
        );
    }

    function informacao(pagamento) {
        console.log(`Pagamentos: ${pagamento}`);
        if (pagamento.nome) {
            return (
                <th>
                    Nome: {pagamento.nome}
                    <br />
                    CPF/CNPJ: {pagamento.cpf}
                    <br />
                    AGENCIA: {pagamento.agencia} <br />
                    CONTA: {pagamento.conta} <br />
                    BANCO: {pagamento.banco}
                </th>
            );
        } else {
            return <th></th>;
        }
    }

    function editPayment(n) {
        axios
            .post(
                `/api/get/payment/${n}`,
                { token },
                {
                    withCredentials: true,
                }
            )
            .then((response) => {
                console.log(response);
                setSelectedPayment(response.data.pay);
                document.querySelector("#anexoDiv").style.display = "block";
                document
                    .querySelector("#anexoEdit")
                    .removeAttribute("disabled");
                if (selectedPayment.tipo == "Acordo") {
                    document.querySelector("#nomes").style.backgroundColor =
                        "white";
                    document.querySelector("#banco").style.backgroundColor =
                        "white";
                    document.querySelector("#cpf").style.backgroundColor =
                        "white";
                    document.querySelector("#agencia").style.backgroundColor =
                        "white";
                    document.querySelector("#conta").style.backgroundColor =
                        "white";
                    document.querySelector("#digito").style.backgroundColor =
                        "white";
                    document.querySelector(
                        "#data_pagamento"
                    ).style.backgroundColor = "white";
                    document.querySelector("#valor").style.backgroundColor =
                        "white";
                }
            });
    }

    return (
        <div className="tab-pane fade" id={id} role="tabpanel">
            <div className="col-12">{modalNovoProcesso()}</div>
            <div className="card-body table-responsive p-0">
                <table className="table table-bordered mt-10">
                    <thead>
                        <tr>
                            <th>Status</th>
                            <th>Download</th>
                            <th>Tipo</th>
                            <th>Descrição</th>
                            <th>Valor</th>
                            <th>Data de Pagamento</th>
                            <th>Informações</th>
                            <th style={{ width: 130 }}>Ação</th>
                        </tr>
                    </thead>
                    <tbody>
                        {responsePagamento.map((pagamento) => (
                            <tr key={pagamento.id}>
                                <td>
                                    <i
                                        className="fas fa-money-bill-wave bg-green center-element"
                                        title={`${pagamento.status}`}
                                        id="money"
                                    >
                                        {" "}
                                    </i>
                                </td>
                                <td>
                                    <a
                                        style={{ color: "green" }}
                                        href={`https://guias.almeidaenogueira.com.br/api/download/pagamento/${pagamento.id}`}
                                    >
                                        <i className="fa fa-cloud-download mr-3" />
                                        {pagamento.anexo}
                                    </a>
                                </td>
                                <td>{pagamento.tipo}</td>
                                <td>{pagamento.descricao}</td>
                                <td>{pagamento.valor}</td>
                                <td>{dataFormato(pagamento.data_pagamento)}</td>
                                <td>{informacao(pagamento)}</td>
                                <td>
                                    <button
                                        className="btn btn-info"
                                        type="button"
                                        data-toggle="modal"
                                        data-target="#updateModal"
                                        onClick={() =>
                                            editPayment(pagamento.id)
                                        }
                                    >
                                        <i className="fas fa-pen" />
                                    </button>
                                    <button
                                        className="btn btn-danger"
                                        type="button"
                                        title="Excluir"
                                        onClick={() =>
                                            deletePagamento(pagamento.id)
                                        }
                                    >
                                        <i className="fa fa-trash" />
                                    </button>
                                </td>
                            </tr>
                        ))}
                        <tr>
                            <th>Total</th>
                            <th></th>
                            <th></th>
                            <th></th>
                            <th>{money(responsePagamento)}</th>
                            <th></th>
                            <th></th>
                            <th></th>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default PagamentosTabAners;
